jQuery(document).ready(function($) {
    "use strict";

    $('.alarm-list__facilities > li').on('click', onClickAlarmListFacility);

    function onClickAlarmListFacility() {
        var $this = $(this);
        var id = $this.data('id');
        if($this.hasClass('active')) {
            $this.removeClass('active');
            $('.id-' + id).hide();
        } else {
            $('.alarm-list__container').hide();
            $('.alarm-list__facilities > li').removeClass('active');
            $this.addClass('active');
            $('.id-' + id).show();
        }
    }

    var $rows = $('.phone-list__list__item');
    if($rows.length === 0) {
        return;
    }

    var people = [];

    var active_filters = {
        facilities: [],
        professions: [],
        intern: false,
        registred: false,
        subscribers: false,
        name: ''
    };

    init();

    var $filter_buttons = $('.phone-list__filters__list li');
    var $reset_button = $('.phone-list__filters__reset-button');
    var $search_by_name_input = $('.phone-list__search input');
    var $person_rows = $('.phone-list__list__item__user-details');
    $person_rows.find('a').on('click', stopPropagationWhenClickingOnUserDetailsLink);

    $filter_buttons.on('click', onClickFilter);
    $reset_button.on('click', onClickResetFilters);
    $search_by_name_input.on('input', onChangeSearchByName);
    $person_rows.on('click', onClickName);

    function onClickName(e) {
        var $this = $(this);
        var $parent = $this.parent();

        $parent.toggleClass('phone-list__list__item--toggled');
    }

    function stopPropagationWhenClickingOnUserDetailsLink(e) {
        e.stopPropagation();
    }

    function onChangeSearchByName(e) {
        var value = e.target.value;

        if(value < 2) {
            if(active_filters.name.length > 2) {
                active_filters.name = '';

                filter();
            }

            return;
        }

        active_filters.name = value.toLowerCase();

        filter();
    }

    function onClickResetFilters(e) {
        e.preventDefault();

        var active_class = 'phone-list__filters__list__item--active';
        $('.' + active_class).removeClass(active_class);
        $search_by_name_input.val('');

        active_filters.facilities = [];
        active_filters.professions = [];
        active_filters.intern = false;
        active_filters.registred = false;
        active_filters.subscribers = false;
        active_filters.name = '';

        filter();
    }

    function onClickFilter(e) {
        e.preventDefault();

        var $this = $(this);
        var profession = $this.data('profession');
        var facility = $this.data('facility');
        var interns = $this.data('interns');
        var registred = $this.data("registred"); // Registred button
        var subscribers = $this.data("subscribers"); // Subscriber button
        
        var active_class = 'phone-list__filters__list__item--active';

        var index = -1;
        if(profession) {
            index = active_filters.professions.indexOf(profession);
            if(index > -1) {
                active_filters.professions.splice(index, 1);
                $this.removeClass(active_class);
            } else {
                active_filters.professions.push(profession);
                $this.addClass(active_class);
            }
        }

        if(facility) {
            index = active_filters.facilities.indexOf(facility);
            if(index > -1) {
                active_filters.facilities.splice(index, 1);
                $this.removeClass(active_class);
            } else {
                active_filters.facilities.push(facility);
                $this.addClass(active_class);
            }
        }

        if(interns) {
            active_filters.intern = !active_filters.intern;
            if(active_filters.intern) {
                $this.addClass(active_class);
            } else {
                $this.removeClass(active_class);
            }
        }

        if (registred) {
            active_filters.registred = !active_filters.registred;
            if (active_filters.registred) {
                $this.addClass(active_class);
            } else {
                $this.removeClass(active_class);
            }
        }

        if (subscribers) {
            active_filters.subscribers = !active_filters.subscribers;
            if (active_filters.subscribers) {
                $this.addClass(active_class);
            } else {
                $this.removeClass(active_class);
            }
        }

        filter();
    }

    function filter() {
        var hitProfession;
        var hitFacility;
        var hitIntern;
        var hitRegistred;
        var hitSubscribers;
        var hitName;

        for(var i = 0, l = people.length, person; i < l; ++i) {
            person = people[i];
            hitProfession = active_filters.professions.length === 0;
            hitFacility = active_filters.facilities.length === 0;
            hitIntern = active_filters.intern === false;
            hitRegistred = active_filters.registred;
            hitSubscribers = active_filters.subscribers;
            hitName = active_filters.name.length === 0;

            for(var j = 0, ll = active_filters.professions.length, profession; j < ll; ++j) {
                profession = active_filters.professions[j];

                if(person.professions.indexOf(profession) > -1) {
                    hitProfession = true;
                    break;
                }
            }

            for(var j = 0, ll = active_filters.facilities.length, facility; j < ll; ++j) {
                facility = active_filters.facilities[j];

                if(person.facilities.indexOf(facility) > -1) {
                    hitFacility = true;
                    break;
                }
            }

            if(person.name.indexOf(active_filters.name) > -1) {
                hitName = true;
            }


            if(active_filters.intern != null && active_filters.intern) {
                hitIntern = person.is_intern;
            }


            // Monster filtering process ...

            if (hitProfession && hitFacility && hitIntern && hitName && hitRegistred) { // Check role registred
                    switch (person.roles) {
                        case "subscriber":
                            person.$el.hide();
                            person.visible = false;
                            continue;

                        case "registrerad":
                            person.$el.show();
                            person.visible = true;
                            continue;

                        default:
                            //person.$el.hide();
                            //person.visible = false;
                            //break;
                            if (hitProfession && hitFacility && hitIntern && hitName) {
                                if (!person.visible) {
                                    person.$el.show();
                                    person.visible = true;
                                }
                            }
                            else {
                                if (person.visible) {
                                    person.$el.hide();
                                    person.visible = false;
                                }
                            }
                    }
            }
            else {
                    //person.$el.show();
                    //person.visible = true;

                if (hitProfession && hitFacility && hitIntern && hitName) {
                    if (!person.visible) {
                        person.$el.show();
                        person.visible = true;
                    }
                }
                else {
                    if (person.visible) {
                        person.$el.hide();
                        person.visible = false;
                    }
                }

            } // End Check role registred



            if (hitProfession && hitFacility && hitIntern && hitName && hitSubscribers) { // Check role subscribers
                switch (person.roles) {
                    case "subscriber":
                        person.$el.show();
                        person.visible = true;
                        continue;

                    case "registrerad":
                        person.$el.hide();
                        person.visible = false;
                        continue;

                    default:
                        //person.$el.hide();
                        //person.visible = false;
                        //break;
                        if (hitProfession && hitFacility && hitIntern && hitName) {
                            if (!person.visible) {
                                person.$el.show();
                                person.visible = true;
                            }
                        }
                        else {
                            if (person.visible) {
                                person.$el.hide();
                                person.visible = false;
                            }
                        }
                }
            }
            else { 
                //person.$el.show();
                //person.visible = true;

                if (hitProfession && hitFacility && hitIntern && hitName) {
                    if (!person.visible) {
                        person.$el.show();
                        person.visible = true;
                    }
                }
                else {
                    if (person.visible) {
                        person.$el.hide();
                        person.visible = false;
                    }
                }

            } // End Check role subscribers






        } // end loop
    }

    function init() {
        for(var i = 0, l = $rows.length, $row; i < l; ++i) {
            $row = $($rows[i]);

            people.push({
                $el: $row,
                name: $row.data('name').toLowerCase(),
                professions: $row.data('professions').split(','),
                facilities: $row.data('facilities').split(','),
                is_intern: $row.data('intern'),
                roles: $row.data("roles"),
                visible: true
            });

        }
    }
    

});

